// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-incomplete-screening-access-restriction.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-incomplete-screening-access-restriction',
  title: 'Apply enhanced access restrictions when employee screening is incomplete',
  description:
    "Where a background screening cannot be completed before work on a contract begins, the employee's access must be restricted to the minimum necessary until screening concludes. The restriction policy must define which system categories are accessible during incomplete screening and ensure compensating controls are in place.",
  category: 'people',
  scfIds: ['SCF-PPL-001', 'SCF-IAM-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Incomplete-screening access restriction procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
